import { postRequest } from '../../helpers/request';

async function getFarmLocations() {
  const data = await postRequest('/dashboard/api/read_farm_locations/');
  return data;
}

export default {
  state: () => ({
    farmLocations: [],
  }),

  mutations: {
    setFarmLocations(state, payload) {
      state.farmLocations = payload;
    },
  },

  actions: {
    async loadFarmLocation({ commit }) {
      const farms = await getFarmLocations();
      commit('setFarmLocations', farms);
    },
  },

  namespaced: true,
};
